/**
 * 合并批量上传分片回包中的 viewUrls/displayUrls（后端为 Map：canonical → 展示 URL）。
 */
export function mergeUploadViewUrlMaps(parts) {
  const viewUrls = {};
  const displayUrls = {};
  let firstViewUrl = '';
  let firstDisplayUrl = '';
  for (const part of parts || []) {
    if (!part || typeof part !== 'object') continue;
    if (part.viewUrls && typeof part.viewUrls === 'object' && !Array.isArray(part.viewUrls)) {
      Object.assign(viewUrls, part.viewUrls);
    }
    if (part.displayUrls && typeof part.displayUrls === 'object' && !Array.isArray(part.displayUrls)) {
      Object.assign(displayUrls, part.displayUrls);
    } else if (part.viewUrls && typeof part.viewUrls === 'object' && !Array.isArray(part.viewUrls)) {
      Object.assign(displayUrls, part.viewUrls);
    }
    if (!firstViewUrl && part.viewUrl) firstViewUrl = String(part.viewUrl);
    if (!firstDisplayUrl && part.displayUrl) firstDisplayUrl = String(part.displayUrl);
  }
  return {
    viewUrls,
    displayUrls: Object.keys(displayUrls).length > 0 ? displayUrls : { ...viewUrls },
    viewUrl: firstViewUrl || Object.values(viewUrls)[0] || '',
    displayUrl: firstDisplayUrl || firstViewUrl || Object.values(displayUrls)[0] || Object.values(viewUrls)[0] || '',
  };
}

/**
 * 从 viewUrls Map 按 url / canonical 查找展示地址。
 */
export function lookupUploadViewUrl(viewUrls, url) {
  if (!viewUrls || typeof viewUrls !== 'object' || Array.isArray(viewUrls) || !url) {
    return '';
  }
  const raw = String(url).trim();
  if (!raw) return '';
  if (viewUrls[raw]) return String(viewUrls[raw]).trim();
  // 兼容带 query / 绝对地址
  const noQuery = raw.split('?')[0];
  if (viewUrls[noQuery]) return String(viewUrls[noQuery]).trim();
  try {
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      const path = new URL(raw).pathname;
      if (viewUrls[path]) return String(viewUrls[path]).trim();
    }
  } catch {
    /* ignore */
  }
  return '';
}
